// Vuex Store
import Vue from 'vue';
import 'es6-promise/auto'; // IE Polyfill for promises (dependency for Vuex)
import Vuex from 'vuex';
import * as types from './modules/types';
import createPersistedState from 'vuex-persistedstate';

// Modules
import loggedinAccount from './modules/loggedinAccount/loggedinAccount';
import token from './modules/token/token';
import user from './modules/user/user';
import path from './modules/path/path';

Vue.use(Vuex);

let store = new Vuex.Store({
    modules: {
        loggedInAccount: loggedinAccount,
        token: token,
        user: user,
        path: path
    },
    plugins: [
        createPersistedState()
    ]
});

store.types = types;

export default store;
